import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-2 p-2" }
const _hoisted_2 = { class: "col-span-12 mb-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "col-span-12 mt-2 mb-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-span-12 mt-2" }
const _hoisted_7 = { class: "col-span-12" }
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "col-span-12 mt-2" }
const _hoisted_11 = { class: "col-span-12" }

import { onMounted, ref } from "vue";
import Menu from "@/base-components/Headless/Menu";
import Lucide from "@/base-components/Lucide/Lucide.vue";
import {
  ColorScheme,
  ITheme,
  Layout,
  MenuPosition,
} from "@/ts/interfaces/theme.interface";
import { loadMessages } from '../../services/translation/translation.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeSettings',
  props: {
  layout: String,
},
  setup(__props) {

const props = __props

const layouts: Layout[] = ["rubick", "enigma", "icewall", "tinker"];
const menuPositions: MenuPosition[] = ["side", "simple", "top"];
const colorSchemes: { id: ColorScheme; color: string }[] = [
  {
    id: "blue",
    color: "bg-blue-800",
  },
  {
    id: "emerald",
    color: "bg-emerald-900",
  },
  {
    id: "indigo",
    color: "bg-blue-900",
  },
  {
    id: "cyan",
    color: "bg-cyan-900",
  },
  {
    id: "violet",
    color: "bg-indigo-900",
  },
  {
    id: "red",
    color: "bg-red-900",
  },
   {
    id: "orange",
    color: "bg-orange-600",
  },
];

const theme = ref();

const defaultTheme = {
  layout: "rubick",
  menuPosition: "side",
  colorScheme: "blue",
  darkMode: false,
};

//set theme
if (!localStorage.getItem("theme")) {
  localStorage.setItem("theme", JSON.stringify(defaultTheme));
}



const themeSettingsId = '3127888342503391838';
const layoutId = '3127218632900215137';
const menuPositionsId = '3127888342503391848';
const colorSchemeId = '3127888342503391855';
const darkModeId = '3127888342503391863';

onMounted(async () => {
  const themeFromLocalstorage = localStorage.getItem("theme");

  if (!themeFromLocalstorage) {
    theme.value = defaultTheme;
  }

  if (themeFromLocalstorage) {
    theme.value = JSON.parse(themeFromLocalstorage);
  }

  setColorScheme();
  setDarkMode();

  const data = [
    themeSettingsId,
    layoutId,
    menuPositionsId,
    colorSchemeId,
    darkModeId
  ];

  await loadMessages(data);
});

function calculatePlacement() {
  if (window.innerWidth > 640) {
    return "bottom-end"
  } else {
    "bottom-start"
  }
}

function setTheme(key: string, value: string) {
  theme.value[key] = value;
  localStorage.setItem("theme", JSON.stringify(theme.value));

  if (key === "colorScheme") {
    setColorScheme();
  }

  if (key === "darkMode") {
    setDarkMode();
  }

  const updateSubApp = ["colorScheme", "darkMode"].includes(key);

  window.dispatchEvent(
    new CustomEvent("updateTheme", { detail: { updateSubApp: updateSubApp } })
  );
}

function setColorScheme() {
  const body = document.body;

  if (!body) {
    return;
  }

  colorSchemes.forEach((scheme: any) => {
    if (body.classList.contains(scheme.id)) {
      body.classList.remove(scheme.id);
    }
  });

  body.classList.add(theme.value.colorScheme);
}

const setDarkMode = () => {
  const body = document.body;

  if (!body) {
    return;
  }

  if (theme.value.darkMode) {
    body.classList.add("dark");
  }

  if (!theme.value.darkMode) {
    body.classList.remove("dark");
  }
  window.dispatchEvent(
    new CustomEvent("updateTheme", { detail: { updateSubApp: true } })
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), {
    id: "",
    class: "intro-x"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Menu).Button, {
        class: _normalizeClass(["relative outline-none block select-none", {
        'text-slate-600': __props.layout === 'rubick' || __props.layout === 'tinker',
        'text-white/70': __props.layout === 'enigma' || __props.layout === 'icewall',
      }])
      }, {
        default: _withCtx(() => [
          _createVNode(Lucide, {
            icon: "Layout",
            class: "notification__icon dark:text-slate-500"
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(Menu).Items, {
        class: "w-[250px] sm:w-[400px] mt-1.5",
        placement: calculatePlacement()
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Menu).Header, { class: "font-normal" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(themeSettingsId)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Menu).Divider, { class: "bg-slate-800/[0.08]" }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(layoutId)), 1),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(layouts, (layout, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(["col-span-6 sm:col-span-3 flex items-center p-2 flex justify-center rounded-md select-none", [
            {
              'bg-primary text-white': layout === theme.value.layout,
              'bg-slate-50 dark:bg-white/10 hover:bg-slate-100 hover:dark:bg-white/20 cursor-pointer':
                layout !== theme.value.layout,
            },
          ]]),
                onClick: ($event: any) => (setTheme('layout', layout)),
                tabindex: "0"
              }, _toDisplayString(layout.charAt(0).toUpperCase() + layout.slice(1)), 11, _hoisted_3)
            }), 64)),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(menuPositionsId)), 1),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuPositions, (menuPosition, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(["col-span-6 sm:col-span-3 flex items-center p-2 flex justify-center rounded-md select-none", [
            {
              'bg-primary text-white': menuPosition === theme.value.menuPosition,
              'bg-slate-50 dark:bg-white/10 hover:bg-slate-100 hover:dark:bg-white/20 cursor-pointer':
                menuPosition !== theme.value.menuPosition,
            },
          ]]),
                onClick: ($event: any) => (setTheme('menuPosition', menuPosition)),
                tabindex: "0"
              }, _toDisplayString(menuPosition.charAt(0).toUpperCase() + menuPosition.slice(1)), 11, _hoisted_5)
            }), 64)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(colorSchemeId)), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colorSchemes, (colorScheme, index) => {
                  return _createElementVNode("div", {
                    key: index,
                    class: _normalizeClass([
                'block w-8 h-8 cursor-pointer rounded-full border-4 mr-1 hover:border-slate-200',
                colorScheme.color,
                {
                  'border-slate-300 dark:border-darkmode-800/80':
                    theme.value.colorScheme === colorScheme.id,
                  'border-white dark:border-darkmode-600':
                    theme.value.colorScheme !== colorScheme.id,
                },
              ]),
                    onClick: ($event: any) => (setTheme('colorScheme', colorScheme.id))
                  }, null, 10, _hoisted_9)
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t(darkModeId)), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass([
              'border w-[38px] h-[24px] p-px outline-none rounded-full relative cursor-pointer',
              'before:content-[\'\'] before:w-[22px] before:h-[22px] before:transition-all before:duration-200 before:shadow-[1px_1px_3px_rgba(0,0,0,0.25)] before:absolute before:inset-y-0 before:my-auto before:rounded-full',
              {
                'bg-primary border-primary': theme.value.darkMode,
                'before:ml-[13px] before:bg-white': theme.value.darkMode,
              },
            ]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setTheme('darkMode', !theme.value.darkMode)))
              }, null, 2)
            ])
          ])
        ]),
        _: 1
      }, 8, ["placement"])
    ]),
    _: 1
  }))
}
}

})